export default __webpack_public_path__ + "static/media/Aus.5fb72ae7.jpg";